<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path d="M0 0h21.621v21.621H0z" />
      <g transform="translate(.759 .759)">
        <path
          :fill="color"
          d="M18.906 18.75a.194.194 0 0 1-.194.193h-1.905a.194.194 0 0 1-.194-.194v-8.502c0-.107.087-.193.194-.193h1.905c.107
        0 .194.086.194.193v8.502zM15.069 3.32a.194.194 0 0 1-.194.194H9.226a.194.194 0 0 1-.194-.193V1.73c0-.107.087-.194.194-.194h5.649c.107
        0 .194.087.194.194v1.59zm0 9.73a.194.194 0 0 1-.194.194H1.738a.194.194 0 0 1-.194-.194V5.244c0-.107.087-.194.194-.194h13.137c.107
        0 .194.087.194.194v7.806zm0 5.7a.194.194 0 0 1-.194.193H5.514a.194.194 0 0 1-.195-.194v-3.776c0-.107.087-.193.195-.193h9.36c.108 0
        .195.086.195.193v3.776zm-11.294 0a.194.194 0 0 1-.194.193H1.738a.194.194 0 0 1-.194-.194v-3.776c0-.107.087-.193.194-.193h1.843c.107
        0 .194.086.194.193v3.776zM5.45 1.127a.443.443 0 0 0-.208.053c.075 0 .146-.02.208-.053zm2.039.602v1.59a.194.194 0 0
        1-.194.194H1.738a.194.194 0 0 1-.194-.193V1.73c0-.107.087-.194.194-.194h5.556c.107 0 .194.087.194.194zm12.447
        6.79h-1.02l-.01-.003h-2.098a.194.194 0 0 1-.194-.193V1.163a.509.509 0 0 0 .02-.139V.512A.514.514 0 0 0 16.118
        0H.438A.436.436 0 0 0 0 .435v19.532c0 .283.23.512.515.512h19.42c.284 0 .515-.23.515-.512V9.032a.513.513 0 0 0-.515-.512z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgFloorplan',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>
